import { Fetch } from 'lib';
import type { FileInfo, ProductSortType, ProductStatus } from 'types';

type RequestResponses = FileInfo;

type RequestParameters = {
  sortType: ProductSortType;
  searchKey: string;
  categoriesIds?: string[];
  brandsIds?: string[];
  statuses?: ProductStatus[];
  callForPrice?: boolean;
  isIndex?: boolean;
  lowerBoundCreateDate?: string;
  upperBoundCreateDate?: string;
};

const exportProducts = async ({
  sortType,
  searchKey,
  categoriesIds,
  brandsIds,
  statuses,
  callForPrice,
  isIndex,
  lowerBoundCreateDate,
  upperBoundCreateDate,
}: RequestParameters) => {
  const params: Record<string, unknown> = {
    sortType,
    searchKey,
  };

  if (categoriesIds) {
    params['categoriesIds'] = categoriesIds;
  }
  if (brandsIds) {
    params['brandsIds'] = brandsIds;
  }
  if (statuses) {
    params['statuses'] = statuses;
  }
  if (typeof callForPrice !== 'undefined') {
    params['callForPrice'] = callForPrice;
  }
  if (typeof isIndex !== 'undefined') {
    params['isIndex'] = isIndex;
  }
  if (lowerBoundCreateDate) {
    params['lowerBoundCreateDate'] = lowerBoundCreateDate;
  }
  if (upperBoundCreateDate) {
    params['upperBoundCreateDate'] = upperBoundCreateDate;
  }

  return await Fetch<RequestResponses, typeof params>({
    url: 'adminProduct/exportProducts',
    params,
  });
};

export { exportProducts };
